export const defaultFonts = [
  { font_family: 'Archivo Narrow', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Archivo Narrow', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Archivo Narrow', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Archivo Narrow', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Lato', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Lato', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Lato', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Lato', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Merriweather', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Merriweather', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Merriweather', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Merriweather', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Montserrat', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Montserrat', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Montserrat', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Montserrat', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '300', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '300', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '600', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '600', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '800', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Open Sans', weight: '800', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Playfair Display', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Playfair Display', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Playfair Display', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Playfair Display', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Roboto Mono', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Roboto Mono', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Roboto Mono', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Roboto Mono', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Space Mono', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Space Mono', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Space Mono', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Space Mono', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '100', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '100', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '200', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '200', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '300', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '300', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '500', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '500', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '600', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '600', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '800', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '800', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '900', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: 'Poppins', weight: '900', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '300', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '400', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '400', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '700', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '700', style: 'italic', sources: [{ format: 'ttf', storage: 'default' }] },
  { font_family: '72', weight: '900', style: 'normal', sources: [{ format: 'ttf', storage: 'default' }] },
];

export const defaultFontFamilies = [...new Set(defaultFonts.map((f) => f.font_family))];

// These font families should only be enabled when beta flag is enabled
export const betaFontFamilies = [];

export const fontWeights = [
  { value: '100', label: 'Thin (100)' },
  { value: '200', label: 'Extra Light (200)' },
  { value: '300', label: 'Light (300)' },
  { value: '400', label: 'Normal (400)' },
  { value: '500', label: 'Medium (500)' },
  { value: '600', label: 'Semi Bold (600)' },
  { value: '700', label: 'Bold (700)' },
  { value: '800', label: 'Extra Bold (800)' },
  { value: '900', label: 'Black (900)' },
];

const fontWeightLabelMapping: Record<string, string | undefined> = {
  100: 'Thin (100)',
  200: 'Extra Light (200)',
  300: 'Light (300)',
  normal: 'Normal', // Deprecated in favor or 400
  400: 'Normal (400)',
  500: 'Medium (500)',
  600: 'Semi Bold (600)',
  bold: 'Bold', // Deprecated in favor of 700
  700: 'Bold (700)',
  800: 'Extra Bold (800)',
  900: 'Black (900)',
};

export const fontStyles = [
  { value: 'normal', label: 'Normal' },
  { value: 'italic', label: 'Italic' },
];

/**
 * Given a font weight value ("normal", "bold" or numeric string)
 * returns a human-readable representation of that weight.
 */
export function getFontWeightLabel(weight: string) {
  const label = fontWeightLabelMapping[weight];
  return label || `${weight}`;
}

/**
 * Given a font style ("normal", "italic")
 * returns a human-readable representation of that style.
 */
export function getFontStyleLabel(style: string): string {
  if (style === 'normal') {
    return 'Normal';
  }
  if (style === 'italic') {
    return 'Italic';
  }
  return style;
}

const extensionToFormatMapping: Record<string, string> = {
  woff: 'woff',
  woff2: 'woff2',
  ttf: 'truetype',
  otf: 'opentype',
  svg: 'svg',
};
const formatToExtensionMapping: Record<string, string> = {
  woff: 'woff',
  woff2: 'woff2',
  truetype: 'ttf',
  opentype: 'otf',
  svg: 'svg',
};

export function getFontFormatByExtension(extension: string) {
  return extensionToFormatMapping[extension];
}

export function getFontExtensionByFormat(format: string) {
  return formatToExtensionMapping[format];
}

/**
 * Ensures that a legacy font weight value is
 * in a recommended numeric string format.
 * @param {*} fontWeight legacy font weight value
 * @returns {string}
 */
export function migrateFontWeight(fontWeight: string) {
  if (fontWeight === 'normal') {
    return '400';
  }
  if (fontWeight === 'bold') {
    return '700';
  }
  if (typeof fontWeight === 'number') {
    return String(fontWeight);
  }
  return fontWeight;
}

export function isFontContentType(contentType: string) {
  return ['application/font-', 'font/'].some((ct) => contentType.startsWith(ct));
}
